import { deserialize, serializable } from 'serializr';

class ClickUpModel {
  @serializable
  public id: string;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ClickUpModel, input));
  }
}

export class ClickUpTeamModel extends ClickUpModel {}

export class ClickUpSpaceModel extends ClickUpModel {}

export class ClickUpFolderModel extends ClickUpModel {}

export class ClickUpListModel extends ClickUpModel {}

export class ClickUpTaskModel extends ClickUpModel {}
